import { defineComponent as _defineComponent } from 'vue';
import AzImg from '~/components/Atoms/AzImg.vue';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
import useMenu from '~/composables/useMenu';
export default /*#__PURE__*/_defineComponent({
  __name: 'MenuItemGraphql',
  props: {
    hideArrow: {
      type: Boolean,
      default: false
    },
    hideImage: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    customArrow: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isActiveArrow: {
      type: Boolean,
      default: false
    },
    underlineOnHover: {
      type: Boolean,
      default: false
    },
    keepTitleIfNoUrl: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useNuxt2App = useNuxt2App(),
      $trackers = _useNuxt2App.$trackers;
    var _useMenu = useMenu(),
      getMenuItemLink = _useMenu.getMenuItemLink;
    var link = computed(function () {
      return getMenuItemLink(props.item);
    });
    return {
      __sfc: true,
      $trackers: $trackers,
      props: props,
      getMenuItemLink: getMenuItemLink,
      link: link,
      AzImg: AzImg,
      NuxtLinkCustom: NuxtLinkCustom
    };
  }
});